var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2851_1449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1D2838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 17.0001C25.5002 18.9719 24.7239 20.8644 23.3391 22.2681C21.9543 23.6718 20.0724 24.4736 18.1008 24.5001H18C16.0846 24.5049 14.2408 23.7719 12.8516 22.4532C12.7919 22.3968 12.7439 22.3292 12.7104 22.2542C12.6769 22.1793 12.6585 22.0984 12.6562 22.0163C12.6539 21.9343 12.6678 21.8525 12.6971 21.7758C12.7264 21.6991 12.7705 21.6289 12.827 21.5693C12.8834 21.5096 12.951 21.4616 13.026 21.4281C13.1009 21.3946 13.1818 21.3762 13.2638 21.3739C13.3459 21.3716 13.4277 21.3855 13.5044 21.4148C13.5811 21.4441 13.6513 21.4882 13.7109 21.5446C14.6045 22.3874 15.7266 22.9481 16.9371 23.1568C18.1475 23.3655 19.3926 23.213 20.5168 22.7182C21.641 22.2233 22.5945 21.4083 23.2582 20.3747C23.9218 19.3411 24.2663 18.1349 24.2484 16.9068C24.2305 15.6786 23.8512 14.483 23.1577 13.4691C22.4642 12.4553 21.4874 11.6683 20.3493 11.2064C19.2112 10.7446 17.9622 10.6283 16.7583 10.8721C15.5545 11.1159 14.4492 11.7091 13.5805 12.5775C13.5741 12.5844 13.5673 12.5909 13.5602 12.597L11.4836 14.5001H13.625C13.7908 14.5001 13.9497 14.566 14.0669 14.6832C14.1842 14.8004 14.25 14.9594 14.25 15.1251C14.25 15.2909 14.1842 15.4498 14.0669 15.5671C13.9497 15.6843 13.7908 15.7501 13.625 15.7501H9.875C9.70924 15.7501 9.55027 15.6843 9.43306 15.5671C9.31585 15.4498 9.25 15.2909 9.25 15.1251V11.3751C9.25 11.2094 9.31585 11.0504 9.43306 10.9332C9.55027 10.816 9.70924 10.7501 9.875 10.7501C10.0408 10.7501 10.1997 10.816 10.3169 10.9332C10.4342 11.0504 10.5 11.2094 10.5 11.3751V13.7032L12.707 11.6876C13.757 10.6417 15.0933 9.93032 16.5473 9.64326C18.0012 9.3562 19.5077 9.50633 20.8764 10.0747C22.2451 10.6431 23.4147 11.6042 24.2376 12.8368C25.0605 14.0694 25.4998 15.5181 25.5 17.0001Z",
    fill: "url(#paint0_linear_2851_1449)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#475569"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2851_1449",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.101961 0 0 0 0 0.164706 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2851_1449"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2851_1449",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2851_1449",
    x1: 25.5,
    y1: 9.50122,
    x2: 9.25,
    y2: 9.50122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#D378F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/Rewind.bd798aee10c86d0cb6b4d1f37516094b.svg";
export { ForwardRef as ReactComponent };